<div class="support">
	<stages-version-check-update-hint></stages-version-check-update-hint>
	@if (appContext$ | async; as application) {
		<ul class="list navigation">
			<li class="list-item">
				<a class="label clickable" (click)="openSettings()">
					<stages-user-image
						[userName]="application.fullname"
						[userId]="application.userId"
						[version]="application.profileImageVersion"
						[sudoMode]="application.superUser"
					></stages-user-image>
					<div class="text">
						<span class="h3">{{ application.fullname }}</span>
					</div>
				</a>
			</li>
			<li class="list-item">
				<a
					class="label clickable"
					href="{{ 'documentation.help.href' | translate }}"
					rel="noopener noreferrer"
					target="_blank"
				>
					<i class="ico ico-help"></i>
					<div class="text">
						<span class="h3" translate="help"></span>
					</div>
				</a>
			</li>
			<!--  smaller-width is set because of WP #32263 -->
			<li class="list-item smaller-width">
				<a id="logout-link" class="label clickable" (click)="logout()">
					<i id="logout-icon" class="ico ico-power-off"></i>
					<div class="text" id="logout-text-container">
						<span class="h3" id="logout-text" translate="logout"></span>
					</div>
				</a>
			</li>
		</ul>
	}
</div>
